import { useTranslation } from "react-i18next";
import { servicesData } from "@/mocks/home";

export default function ServicesSection() {
  const { t } = useTranslation("home");

  return (
    <section className="w-full bg-white py-12 md:py-20">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-magenta text-center mb-8 md:mb-12 uppercase tracking-wide">
          {t("services.title")}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {servicesData.map((service) => (
            <div
              key={service.id}
              className="group bg-white border border-gray-100 rounded-lg overflow-hidden hover:shadow-md transition-shadow"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={t(`services.${service.id}.title`)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h4 className="text-lg font-bold text-brandgreen mb-3">
                  {t(`services.${service.id}.title`)}
                </h4>
                <p className="text-sm text-text-muted leading-relaxed text-justify">
                  {t(`services.${service.id}.desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}